import { SuperAdminConstants } from '../../../_constants';

const initialState = { getAssessmentOrganisationLoading: true, data: '', error: false };

export function getAssessmentOrganisationReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ASSESSMENT_ORGANISATION:
            return {
                getAssessmentOrganisationLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ASSESSMENT_ORGANISATION:
            return {
                getAssessmentOrganisationLoading: false,
                data: action.getAssessmentOrganisation,
                error: false
            };
        case SuperAdminConstants.GET_ASSESSMENT_ORGANISATION_ERROR:
            return {
                getAssessmentOrganisationLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AddOrganisation/getAssessmentOrganisation.reducer.js